// eslint-disable-next-line import/prefer-default-export
export const paginationSerializer = (data) => ({
  pageIndex: data.pageIndex,
  pageSize: data.pageSize,
  totalPages: data.pageIndex
})
